import { useMemo } from 'react';
import { AvatarNamedColor, AvatarProps, Avatar as FluentAvatar, Tooltip } from '@fluentui/react-components';

import { ControlledTooltip } from '@shared/components/ControlledTooltip';

import type { TUser } from '../types/users.types';

// https://medium.com/web-dev-survey-from-kyoto/how-to-customize-the-file-upload-button-in-react-b3866a5973d8

export type TAvatarProps = AvatarProps & {
  user?: TUser;
  color?: 'brand' | 'neutral' | 'colorful' | AvatarNamedColor | undefined;
  tooltip?: 'none' | 'name' | 'mail';
};

const Avatar = ({ user, color = 'colorful', tooltip = 'none', ...avatarProps }: TAvatarProps) => {
  const name = user?.name || '';
  const initials = useMemo(() => {
    if (!name || name.length < 1) return '?';
    const nameParts = name.split(' ');
    if (nameParts.length < 2) return name[0];
    return nameParts[0][0] + nameParts[nameParts.length - 1][0];
  }, [name]);

  if (!user)
    return (
      <Tooltip withArrow relationship="description" content="User was not found.">
        <FluentAvatar {...avatarProps} />
      </Tooltip>
    );

  const tooltipContent = tooltip === 'name' ? name : tooltip === 'mail' ? user.mail : '';

  return (
    <ControlledTooltip withArrow content={tooltipContent} relationship="inaccessible" enable={tooltip !== 'none'}>
      <FluentAvatar initials={initials} color={color} idForColor={user._id} {...avatarProps} />
    </ControlledTooltip>
  );
};

export default Avatar;
